import React from 'react';

import { FieldHint } from './FieldHint';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  hint?: string;
  showCharacterCount?: boolean;
  maxLength?: number;
}

export const Textarea: React.FC<TextareaProps> = ({
  label,
  error,
  hint,
  showCharacterCount = false,
  maxLength,
  className = '',
  value,
  onChange,
  ...props
}) => {
  const currentLength = typeof value === 'string' ? value.length : 0;

  return (
    <div className="w-full">
      {label && (
        <label
          className="block text-neutral-700 mb-1.5"
          style={{
            fontFamily: 'Oxygen',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '20px',
          }}
        >
          {label}
        </label>
      )}
      <textarea
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        className={`w-full px-3 py-2 border rounded-lg text-base transition-colors resize-y ${
          error
            ? 'border-error-500 focus:ring-error-500'
            : 'border-neutral-300 focus:ring-primary-500'
        } focus:outline-none focus:ring-2 disabled:bg-neutral-100 disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
        {...props}
      />
      <div className="flex justify-between items-center mt-1">
        <div className="flex-1">
          {error && <p className="text-error-500 text-sm">{error}</p>}
          {/* mt-0: the wrapping row already supplies the top margin. */}
          {hint && !error && <FieldHint className="mt-0">{hint}</FieldHint>}
        </div>
        {showCharacterCount && maxLength && (
          // Was text-neutral-500 (#cfd4dc) — a border tint, ~1.4:1 on white and
          // effectively invisible. Secondary text belongs on the hint colour.
          <p className="text-neutral-550 text-sm ml-2">
            {currentLength}/{maxLength}
          </p>
        )}
      </div>
    </div>
  );
};

export default Textarea;
